import { render, staticRenderFns } from "./SubjectReaction.vue?vue&type=template&id=3a7c18be&scoped=true&"
import script from "./SubjectReaction.vue?vue&type=script&lang=ts&"
export * from "./SubjectReaction.vue?vue&type=script&lang=ts&"
import style0 from "./SubjectReaction.vue?vue&type=style&index=0&id=3a7c18be&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a7c18be",
  null
  
)

export default component.exports